"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zip = zip;

function zip(firstCollection, lastCollection) {
  return firstCollection.map(function (firstItem, index) {
    return [firstItem, lastCollection[index]];
  });
}